
export class CorporateIdentity {
    primaryColor = "#678fbdff";
    primaryTextColor = "#fff";
    badgeColor = "#e42a7b";
    topbarBgColor = "#58799f";
    topbarBgColorDark = "#3b5471";
    topbarLogoBgColor: string = null;
    topbarLogoPadding = "0px";
    topbarLogoHeight = "60px";
    loginLogoBackgroundColor: string = null;
    loginLogoPadding = "0px";

    constructor(data?: Partial<CorporateIdentity>) {
        if (data != null) {
            Object.assign(this, data);
        }
    }
}